import {ClipboardIcon} from '@heroicons/react/24/outline';
import classNames      from 'classnames';
import React           from 'react';

export function TorchlightCollectionItem({
	                                         className,
	                                         child,
	                                         innerRef,
                                         }) {
	return (<div className={classNames('flex flex-col torchlight-collection relative', className)}
	             ref={innerRef}
	>
		<div className="flex bg-gray-800/40 ring-1 ring-white/5 flex-shrink-0">
			<div className="-mb-px flex text-sm font-medium leading-6 text-gray-400">
				<button className={classNames([
					'px-3 py-2 text-white cursor-pointer select-none outline-0 border-r bg-white/5 border-b border-b-white/20 border-gray-600/10',
				])}
				>
					{child.props.name}
				</button>

				<button className="absolute top-12 right-2 text-white/50 hover:text-white z-10 bg-white/5 hover:bg-white/25 p-1 rounded-lg"
				        title="Copy to clipboard"
				        onClick={() => navigator.clipboard.writeText(child.props.children)}
				>
					<ClipboardIcon className="h-5 w-5" />
				</button>
			</div>
		</div>

		<div className="flex-1 flex overflow-x-auto">
			{React.cloneElement(React.Children.only(child), {includeCopy: false})}
		</div>
	</div>);
}
